import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const PathwayInfoEntry = ({ label, value }) => {
  return (
    <span>
      <b>
        {label}
        {": "}
      </b>
      {value}
    </span>
  );
};

export default PathwayInfoEntry;

export const PathwayInfoLink = ({ label, value, url }) => {
  return (
    <span>
      <b>
        {label}
        {": "}
      </b>
      <span>
        {value} &nbsp;
        <a href={url} target="_blank">
          <FontAwesomeIcon
            icon="fa-solid fa-arrow-up-right-from-square"
            color={"#4169e1"}
          />
        </a>
      </span>
    </span>
  );
};
